<form [formGroup]="syntheseForm">
	<div class="synthesis-component formulaire pb-3">
		<div class="row">
			<div [ngClass]="{'col-5': innerWidth > 1560}">
				<div class="mb-3">
					<h3>{{ visualiserMessages.synthese_intitule | translate }}</h3>
					<span>{{ synthesis.intitule }}</span>
				</div>
				<div class="d-flex">
					<h3>{{ visualiserMessages.synthese_support | translate }}</h3>
					<div class="ml-auto">
						<button aria-label="annuler" (click)="cancelSubmit()" type="button"  class="btn btn-outline-primary">{{ visualiserMessages.annuler | translate }}</button>
						<button aria-label="enregistrer" (click)="updateSynthese()" type="button"  class="btn btn-primary">
							{{ visualiserMessages.enregistrer | translate }}
						</button>
					</div>
				</div>
				<ul role="list">
					<ng-container *ngFor="let support of synthesis?.supportDiffusionList; let i = index">
						<li class="d-flex" role="listitem" *ngIf="support.code == ''; else hassupportList">
							<a role="link" target="_blank" [style.pointer-events]="!support.lien ? 'none' : 'auto'" [style.text-decoration]="!support.lien ? 'none' : 'underline'" [href]="support.lien">
								{{ support.libelle }}
								<mat-icon aria-hidden="true" class="launch-icon" inline="true" role="img" *ngIf="support.lien">launch</mat-icon>
							</a>
              <span
                class="tag ml-auto" [class]="statusHelper.getStatusClass(statusState[(support.status === 'PUBLIE' && !(support.lien?.trim()?.length)) ? 'ENVOYE' : support.status])">
                {{ statusState[(support.status === 'PUBLIE' && !(support.lien?.trim()?.length)) ? 'ENVOYE' : support.status] }}
              </span>
						</li>
						<ng-template #hassupportList>
							<li role="listitem">
								{{ support.code }} - {{ support.libelle }}
								<ng-container *ngFor="let listeDiffusionList of support?.listeDiffusionList;">
									<ul role="list">
										<li class="d-flex" role="listitem">
											<a role="link" [href]="listeDiffusionList.lien"
												>{{ listeDiffusionList.libelle }}
												<mat-icon aria-hidden="true" class="launch-icon" inline="true" role="img">launch</mat-icon>
											</a>
												<select formControlName="status-{{i}}" id="status{{i}}" (change)="selectStatus()" role="combobox" class="ml-auto">
													<option *ngFor="let element of listeDiffusionList.statutFluxList" [value]="element" [selected]="element === listeDiffusionList.status">
														{{ statusState[element] }}
													</option>
													<option *ngIf="listeDiffusionList.statutFluxList.length === 0" [value]="listeDiffusionList.status">
														{{ statusState[listeDiffusionList.status] }}
													</option>
												</select>
										</li>
									</ul>
								</ng-container>
							</li>
						</ng-template>
					</ng-container>
				</ul>
			</div>
		</div>
	</div>
</form>
